var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingSideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35409 8.73243C5.91762 8.65674 6.48114 8.85019 6.88066 9.2497L7.88996 10.259L8.84459 9.30858L7.46521 7.9334C7.25074 7.71893 7.25074 7.36988 7.46521 7.1554C7.67969 6.94092 8.02874 6.94092 8.24321 7.1554L9.62259 8.53478L10.5772 7.58435L9.56372 6.57085C9.1642 6.17133 8.97075 5.6036 9.04645 5.04428C9.21467 3.76583 8.80674 2.42851 7.82688 1.44444C6.82599 0.44355 5.45502 0.03983 4.15555 0.233279C3.94948 0.262717 3.86537 0.519248 4.01256 0.666438L5.31204 1.96591C5.93023 2.58411 5.93023 3.585 5.31204 4.19899L4.51301 4.99802C3.89481 5.61622 2.89392 5.61622 2.27993 4.99802L0.976252 3.69854C0.829062 3.55136 0.576737 3.63546 0.543094 3.84153C0.349644 5.141 0.753365 6.51197 1.75425 7.51286C2.73832 8.49272 4.07565 8.90065 5.35409 8.73243Z",
    fill: "#0854A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4363 10.4441L12.4817 11.3945L18.1506 17.0634C18.365 17.2779 18.365 17.6269 18.1506 17.8414C17.9361 18.0559 17.587 18.0559 17.3726 17.8414L11.7037 12.1725L10.749 13.1229L16.5904 18.9643C17.3305 19.7044 18.529 19.7002 19.2692 18.9601C20.0094 18.2199 20.0094 17.0214 19.2734 16.2812L13.4363 10.4441Z",
    fill: "#0854A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.628 6.65923H18.1471L20.6661 1.62534L19.4087 0.36792L14.3706 2.88276V5.40181L7.52419 12.2272L6.29201 10.9992L1.32961 15.9616C0.295078 16.9961 0.295078 18.6699 1.32961 19.7044C2.36414 20.739 4.0379 20.739 5.07243 19.7044L10.0348 14.742L8.77741 13.4846L15.628 6.65923Z",
    fill: "#FDC453"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingSideIcon);
export default __webpack_public_path__ + "static/media/setting-side-icon.5b0eb52b5577afc950ebf4db08043ebe.svg";
export { ForwardRef as ReactComponent };